<div class="w-100">
  <footer class="flex-rw d-flex align-items-center">
    <div class="waves">
      <div class="wave" id="wave1"></div>
      <div class="wave" id="wave2"></div>
      <div class="wave" id="wave3"></div>
      <div class="wave" id="wave4"></div>
    </div>
    <ul class="footer-list-top text-center px-5">
      <li>
        <h4 class="footer-list-header title">SOBRE YACHAY</h4>
      </li>
      <img src="../../assets/image/recursos/Yachay.png" class="img-fluid" width="50%" alt="">
      <p class="text-white subtitle fw-bold lh-sm">Sistema de venta con gestión de inventario y facturación electrónica.
      </p>
    </ul>
    <ul class="footer-list-top">
      <li><h4 class="footer-list-header title">NAVEGACIÓN</h4></li>
      <li><a href='/Angels/cat/id/70' class="generic-anchor footer-list-anchor">COMERCIO</a></li>
      <li><a href='/Home-Decor/cat/id/64' class="generic-anchor footer-list-anchor">HOTELES</a></li>
      <li><a href='/Mugs/cat/id/32' class="generic-anchor footer-list-anchor">RESTAURANTE</a></li>
      <li><a href='/Pet-Lover/cat/id/108' class="generic-anchor footer-list-anchor">AGENCIA</a></li>
      <li><a href='/Ladies-Accessories/cat/id/117' class="generic-anchor footer-list-anchor" target="_blank">NOSOTROS</a></li>
    </ul>
    <ul class="footer-list-top">
      <li id='help'><h4 class="footer-list-header title">ATENCIÓN Y SOPORTE</h4></li>
      <li><a routerLink="/contacto" class="generic-anchor footer-list-anchor" itemprop="significantLink">CONTACTO</a></li>
      <!-- <li><a href='/faq.html' class="generic-anchor footer-list-anchor" itemprop="significantLink">FAQ</a></li> -->
      <p class="text-center fw-bold text text-white mb-1"><small>Herramientas de soporte:</small></p>
      <li id='find-a-store'><a href='https://anydesk.com/es' target="_blank" class="generic-anchor footer-list-anchor" itemprop="significantLink">ANYDESK</a></li>
      <li id='user-registration'><a href='https://www.teamviewer.com/en-us/download/windows/' target="_blank" class="generic-anchor footer-list-anchor" itemprop="significantLink">TEAM WIVER</a></li>
      <li id='order-tracking'><a href='/shop/order-status' itemprop="significantLink" class="generic-anchor footer-list-anchor">WHATSAPP</a></li>
    </ul>
    <section class="footer-social-section flex-rw">
      <span class="footer-social-overlap footer-social-connect">
        CONÉCTATE <span class="footer-social-small">con</span> Nosotros
      </span>
      <span class="footer-social-overlap footer-social-icons-wrapper">
        <a href="#" class="generic-anchor" target="_blank" title="Pinterest" itemprop="significantLink"><i
            class="fab fa-pinterest"></i></a>
        <a href="#" class="generic-anchor" target="_blank" title="Facebook" itemprop="significantLink"><i
            class="fab fa-facebook"></i></a>
        <a href="#" class="generic-anchor" target="_blank" title="Twitter" itemprop="significantLink"><i
            class="fab fa-twitter"></i></a>
        <a href="#" class="generic-anchor" target="_blank" title="Instagram" itemprop="significantLink"><i
            class="fab fa-instagram"></i></a>
        <a href="#" class="generic-anchor" target="_blank" title="Youtube" itemprop="significantLink"><i
            class="fab fa-youtube"></i></a>
        <a href="#" class="generic-anchor" target="_blank" title="Google Plus" itemprop="significantLink"><i
            class="fab fa-google-plus"></i></a>
      </span>
    </section>
    <section class="footer-bottom-section flex-rw">
      <div class="footer-bottom-wrapper">
        <i class="fa fa-copyright" role="copyright">
        </i> 2021 Develop for <address class="footer-address" role="company address">YACHAY ACPRODEC, CUSCO - PERU
        </address><span class="footer-bottom-rights"> - All Rights Reserved - </span>
      </div>
      <div class="footer-bottom-wrapper">
        <a href="/terms-of-use.html" class="generic-anchor" rel="nofollow">Terms</a> | <a href="/privacy-policy.html"
          class="generic-anchor" rel="nofollow">Privacy</a>
      </div>
    </section>
  </footer>
</div>
